export default function LegalPage({ title, children }) {
  return (
    <div className="max-w-4xl mx-auto px-4 pb-12">
      <h1 className="font-climate text-3xl md:text-5xl text-brand-blue mb-8 md:mb-12 text-center">
        {title}
      </h1>
      <article className="space-y-6 text-gray-800 leading-relaxed [&_h2]:font-display [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-brand-blue [&_h2]:mt-8 [&_h2]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:mb-2 [&_strong]:font-bold">
        {children}
      </article>
    </div>
  )
}
